import { render, staticRenderFns } from "./PasswordResetPage.vue?vue&type=template&id=be54fe80&scoped=true&"
import script from "./PasswordResetPage.vue?vue&type=script&lang=ts&"
export * from "./PasswordResetPage.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordResetPage.vue?vue&type=style&index=0&id=be54fe80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be54fe80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})
